import React from 'react';
import * as constants from '../../constants';
import * as DocumentHelpers from '../document/DocumentHelpers';
import { getArrayIds, getCurrentUrlPath, parseFilterString, resizeTabs } from '../helpers/HelperFunctions';
import * as ModalDialog from '../ModalDialog';
import { History } from '../helpers/History';
import { getOnPageCount } from '../helpers/StorageHelper';
import { Table } from '../table/Table';
import { TableFilterBlock } from '../table/TableFilterBlock';
import { BatchSignForm } from '../forms/BatchSignForm';
import { ListTabs } from './ListTabs';
import * as ListHelpers from './ListHelpers';
import i18next from "../../i18n";
const mime = require("mime-types");
export function inboxNavigate(index) {
    const nextLocation = getCurrentUrlPath().toLowerCase();
    const { location, selectedInboxNumber } = this.state;
    if (nextLocation !== location || index !== selectedInboxNumber) {
        this.setState({ selectedInboxNumber: index, location: nextLocation, page: 1 });
        const { sortBy, isDesk, filterValues, pageSize } = this.state;
        var allowedValues = this.getAllowedEnumValues(index);
        if (allowedValues["Status"] && allowedValues["Status"].length > 0
            && filterValues["Status"] && filterValues["Status"].length > 0
            && !(filterValues["Status"].length === 1 && filterValues["Status"][0] === 'hideAllValue')) {
            if (filterValues["Status"].filter(it => allowedValues["Status"].includes(it)).length === 0)
                filterValues["Status"] = [];
        }
        this.loadData(1, pageSize, sortBy, isDesk, filterValues);
    }
}
export function getSelectedMenuItem() {
    let curUrl = getCurrentUrlPath();
    const { menuItems } = this.state;
    if (menuItems.length > 0) {
        let tabIndex = menuItems.findIndex(item => item.link && item.link.url === curUrl);
        if (tabIndex >= 0) {
            return menuItems[tabIndex];
        }
    }
}
export function getAllowedEnumValues(inbox = -1) {
    let result = {};
    let selectedMenuItem = this.getSelectedMenuItem();
    if (inbox === -1)
        inbox = this.state.selectedInboxNumber;
    if (selectedMenuItem) {
        let statuses;
        if (selectedMenuItem?.inBoxes?.length > inbox) {
            let currentInbox = selectedMenuItem.inBoxes[inbox];
            statuses = currentInbox.counter?.settings?.Status;
        }
        if (!statuses)
            statuses = selectedMenuItem.counter?.settings?.Status;
        if (statuses && statuses.length > 0) result["Status"] = statuses;
    }
    return result;
}

export function getFilterValuesFromMenu(filterValues, menuItems = null) {
    let inbox = this.state.selectedInboxNumber;
    let additionalFilers = {};
    if ((!menuItems ? menuItems = this.state.menuItems : menuItems).length > 0) {
        var index = menuItems.findIndex(item => item.link?.url.toLocaleLowerCase() === getCurrentUrlPath().toLocaleLowerCase());
        if (index >= 0) {
            if (inbox >= 0 && menuItems[index]?.inBoxes?.length > inbox) {
                var currentInBox = menuItems[index].inBoxes[inbox];
                if (currentInBox.counter?.settings?.Filter?.length > 0) {
                    for (let i = 0; i < currentInBox.counter.settings.Filter.length; i++) {
                        let values = parseFilterString(currentInBox.counter.settings.Filter[i]);
                        additionalFilers = Object.assign(additionalFilers, values);
                    }
                }
            }
            if (menuItems[index]?.counter?.settings?.Filter?.length > 0) {
                for (let i = 0; i < menuItems[index].counter.settings.Filter.length; i++) {
                    let values = parseFilterString(menuItems[index].counter.settings.Filter[i]);
                    additionalFilers = Object.assign(additionalFilers, values);
                }
            }
        }
    }
    Object.keys(additionalFilers).forEach(name => {
        if (filterValues[name] && filterValues[name].length > 0) {
            filterValues[name] = additionalFilers[name].filter(item => filterValues[name].includes(item));
        }
        else {
            filterValues[name] = additionalFilers[name];
        }
    });

    return filterValues;
}
export async function actionHandlerCallback(actionType, ids) {
    const { actionHandlerCallback } = this.props;
    let currentObject = this;
    if (actionHandlerCallback) actionHandlerCallback(actionType, ids);
    else {
        // eslint-disable-next-line default-case
        switch (actionType) {
            case constants.actionTypes.batchOperations:
                let closeDialog = async function () {
                    ModalDialog.hideModalDialog('modalDialog');
                    currentObject.handleReloadData();
                }
                ModalDialog.showModalDialog('modalDialog', i18next.t("batchSignForm.formHeader"), "",
                    <BatchSignForm docIds={ids} onClose={closeDialog} companyName={this.context.companies[0].companyShortName} />,
                    "feedPopup middle-size batch-form", true, [], closeDialog);
                break;
            case constants.actionTypes.download:
                await Promise.all(ids.map((id) => DocumentHelpers.downloadFile(id, "", "", true)));
                break;
            case constants.actionTypes.loadP7s:
                let data = await DocumentHelpers.getPs7Zip(ids);
                if (!data.errorCode) {
                    let anchor = document.createElement("a");
                    anchor.href = `data:${data.mimeType};base64,${data.content}`;
                    anchor.download = `${data.fileName}.${mime.extension(data.mimeType)}`;
                    anchor.click();
                }
                else {
                    let errorMessage = data.errorCode === 404 ? i18next.t("ps7ZipNotFound") : i18next.t("unknownErrorMessage");
                    ModalDialog.showModalDialog('modalDialog', i18next.t("error"), "", <div className="info-message">{errorMessage}</div>, "feedPopup", true, [{ title: i18next.t("ok"), clickHandler: () => ModalDialog.hideModalDialog('modalDialog'), class: "btn-primary" }]);
                }
                break;
            case constants.actionTypes.previewMainDocument:
                require('../ModalDialogsTemplates').viewPdfDialog(ids[0]);
                break;
            case constants.actionTypes.preview:
                History.push(`/document/${constants.formModes.read}/${ids[0]}`);
                break;
            case constants.actionTypes.remove:
                let confirmDialog = async function () {
                    let promises = [];
                    for (let i = 0; i < ids.length; ++i) {
                        promises.push(DocumentHelpers.deleteDocument(ids[i]));
                    }
                    await Promise.all(promises);
                    ModalDialog.hideModalDialog('modalDialog');
                    currentObject.handleReloadData();
                }
                ModalDialog.showModalDialog("modalDialog", i18next.t("removing"), "",
                    <div className="info-message">{i18next.t("removeDocumentsMessage")}</div>,
                    "feedPopup", true,
                    [
                        { title: i18next.t("yes"), clickHandler: confirmDialog, class: "btn-primary" },
                        { title: i18next.t("no"), clickHandler: () => ModalDialog.hideModalDialog('modalDialog'), class: "btn-secondary" }
                    ]);
                
                break;
        }
    }
    await this.actionHandlerCallbackDefault(actionType, ids);
}
export function renderContent() {
    const { type, typeOfMenu, actionsForAll } = this.props;
    const { content, page, pageSize, pageCount, sortBy, isDesk, menuItems, filterValues, selectedInboxNumber } = this.state;
    if (content?.rows) {
        const user = JSON.parse(localStorage.getItem('user'));
        content.rows.forEach(row => {
            let deleteActionIndex = row.actions.findIndex(a => a.type == constants.actionTypes.remove);
            if (deleteActionIndex >= 0 && row.columns['AuthorEmail'] !== user.email && row.columns['ResponsiblePersonEmail'] !== user.email) {
                row.actions.splice(deleteActionIndex, 1);
            }
        });
    }
    let inBoxIndex = 0;
    let selectedMenuItem = this.getSelectedMenuItem();
    let allowedEnumValues = this.getAllowedEnumValues();
    const filteredItems = menuItems?.filter(item => !item.hiddenForTabs);
    return (
        <>
            {this.props.title && <h1>{this.props.title}{type === "" && <span className="title-counter">{content?.allCount ? content?.allCount : 0}</span>}</h1>}
            {typeOfMenu && <ListTabs items={filteredItems} selectedItem={selectedMenuItem} />}
            <div className="docs-page-block" type={typeOfMenu} >
                {selectedMenuItem && selectedMenuItem.inBoxes && selectedMenuItem.inBoxes.length > 0 &&
                    <div className="inboxes">
                        <ul>
                            {selectedMenuItem.inBoxes.map((item, index) =>
                                <li className={inBoxIndex === selectedInboxNumber ? "active" : ""} key={item.name ? item.name + '_' + inBoxIndex++ : inBoxIndex++}
                                    onClick={() => this.inboxNavigate(index)}>
                                    {item.title} {item.counter && !item.counter.hidden ? <span className={"left-menu-counter" + (index === selectedInboxNumber ? " selected" : "")}>{item.counter?.count}</span> : ""}
                                </li>
                            )}
                        </ul>
                    </div>
                }
                {getCurrentUrlPath() !== "/" &&
                    <TableFilterBlock allowedEnumValues={allowedEnumValues} filterValues={filterValues} onColumnsUpdateHandler={this.onColumnsUpdateHandler} exportFileName="documents" onSearch={this.onSearch} onSearchClear={this.onSearchClear} columnsSettings={{ columns: (content && content.allColumns) ? content.allColumns : [], selected: (content && content.columns) ? getArrayIds(content.columns) : [] }} getItems={this.getItemsForExport} handleUpdate={this.handleReloadData} />
                }
                {content && content.columns &&
                    <Table allowedEnumValues={allowedEnumValues} onColumnFilter={this.onColumnFilter} allCount={content.allCount} allowDoubleClickAction={true} handleSortChange={this.handleSortChange} actionHandlerCallback={this.actionHandlerCallback} sortBy={sortBy} isDesk={isDesk} columns={content.columns} items={content.rows} showMoreLink={getCurrentUrlPath() === "/"} showPagination={getCurrentUrlPath() !== "/"} page={page} pageSize={pageSize} pageCount={pageCount} handlePageChange={this.handlePageChange} handleChangePageSize={this.handleChangePageSize} actionsForAll={actionsForAll ? actionsForAll.concat(content.actionsForAll) : content.actionsForAll} />
                }
            </div>
        </>
    );
}
export function getSettingsValue(menuItems, name) {
    if ((!menuItems ? menuItems = this.state.menuItems : menuItems).length > 0) {
        var index = menuItems.findIndex(item => item.link?.url.toLocaleLowerCase() === getCurrentUrlPath().toLocaleLowerCase());
        if (index >= 0 && menuItems[index]?.counter?.settings[name]?.length > 0)
            return menuItems[index].counter.settings[name];
    }
    return [];
}
export async function loadDocuments(sortBy = '', isDesk = false, filterValues = [], menuItems = [], page = null, pageSize = null, inbox = -1) {
    const { type, withAction } = this.props;
    inbox = inbox ?? this.state.selectedInboxNumber;
    var allowedValues = this.getAllowedEnumValues();
    let getUpdatedFilterValues = (values = [], key = "") => {
        if (allowedValues[key]?.length > 0) {
            if (values.length === 1 && values[0] === "*")
                return allowedValues[key];
            else
                return values.filter(item => allowedValues[key].includes(item));
        }
    }
    let requestFilterValues = Object.assign({}, filterValues);
    requestFilterValues = this.getFilterValuesFromMenu(requestFilterValues, menuItems);

    const statusAndTypeFilters = [{ name: "Status" }, { name: "Type" }]
        .map(item => ({ name: item.name, values: (requestFilterValues[item.name]?.length > 0 ? requestFilterValues[item.name] : this.getSettingsValue(menuItems, item.name)) }))
        .map(item => {
            if (item.values?.length === 0)
                item.values = ["*"];
            return item;
        })
        .map(item => ({ name: item.name, values: getUpdatedFilterValues(item.values, item.name) ?? item.values }))
        .map(item => {
            if (item.values?.length > 0)
                item.values = item.values.filter(v => v !== "*");
            return item;
        })
        .filter(item => item.values?.length > 0);

    statusAndTypeFilters.forEach(item => {
        requestFilterValues[item.name] = item.values;
    });

    if (requestFilterValues['Type']) {
        requestFilterValues['DocType'] = requestFilterValues['Type'];
        delete requestFilterValues['Type'];
    }

    let loadUrl = `Table/Get?searchTableTypes=${type}${withAction !== undefined ? `&withAction=${withAction}` : ""}`;

    await ListHelpers.loadListData.bind(this)(loadUrl,
        page ?? this.state.page, pageSize ?? this.state.pageSize, sortBy, isDesk, requestFilterValues);
    this.setState({ menuItems: menuItems });
}
export async function loadData(page = null, pageSize = null, sortBy = '', isDesk = false, filterValues = []) {
    const { typeOfMenu, additionalFilter } = this.props;
    filterValues = additionalFilter ? Object.assign(JSON.parse(JSON.stringify(additionalFilter)), filterValues) : filterValues;
    const component = this;

    if (typeOfMenu !== constants.menuTypes.WithoutMenu) {
        let inBoxUrl = typeOfMenu !== constants.menuTypes.Pending ? getCurrentUrlPath() : '';
        await fetch(`menu/GetLeftMenu?${this.context.companies[0].companyKindValue}&type=${typeOfMenu ? typeOfMenu : ""}&inBoxUrl=${inBoxUrl}`).then(async (response) => {
            if (response.status === 403) {
                component.setState({
                    content: null,
                    menuItems: [],
                    update: true,
                    pageCount: 0,
                    pageSize: getOnPageCount(),
                    page: 1,
                    sortBy: '',
                    isDesk: false,
                    filterValues: [],
                    location: getCurrentUrlPath().toLowerCase(),
                    wasFiltered: false
                });
            }
            else if (!response.ok) require('../ModalDialogsTemplates').unknownErrorMessageDialog();
            else {
                const data = (await response.json())?.menu?.menuItems;
                await loadDocuments.bind(component)(sortBy, isDesk, filterValues, data, page, pageSize);
            }
        });
    }
    else
        await loadDocuments.bind(component)(sortBy, isDesk, filterValues, [], page, pageSize);
}